import { Box, Typography } from "@mui/material";

export default function MaintenancePage() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
        bgcolor: "#f5f5f5",
      }}
    >
      <Typography
        component="h1"
        variant="h5"
        align="center"
        sx={{ maxWidth: 480, color: "text.primary", fontWeight: 600 }}
      >
        App under maintenance, apologies for inconvenience!
      </Typography>
    </Box>
  );
}
